import {
    IonHeader,
    IonLabel,
    IonSegment,
    IonSegmentButton,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

interface _Props {
    active: string
    onSelect: Function
}

const EventAlertsNavbar: React.FC<_Props> = ({active, onSelect}) => {
    const [currentActiveBtn, setCurrentActiveBtn] = useState(active || "alerts");

    useEffect(() => {
        setCurrentActiveBtn(active);
    }, [active]);

    const handleSelection = async (selection: string) => {
        await setCurrentActiveBtn(selection);
        onSelect(selection);
    }

    return (
        <IonHeader id="viewEventMenu">
            <IonSegment color="primary" mode="md" value={currentActiveBtn || active} scrollable={true} onIonChange={e => {handleSelection(e.detail.value || "about");}}>
                <IonSegmentButton value="alerts">
                    <IonLabel>Alerts</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="subscribers">
                    <IonLabel>Subscribers</IonLabel>
                </IonSegmentButton>
                <IonSegmentButton value="credits">
                    <IonLabel>Credits</IonLabel>
                </IonSegmentButton>
            </IonSegment>
        </IonHeader>
    );
};

export default EventAlertsNavbar;
